// Technical Dashboard colour rule (2026-08-29, per user decision):
// "Heike Kolar" always gets the pink shade; every other named technician
// cycles through dark-gold / gold / amber / orange; "Unassigned" is grey.
// Anything computed dynamically from real technician_name values — no
// other names are ever hard-coded.
export const TECH_PALETTE = ["#96762B", "#C9A227", "#C2790A", "#D9722B"];
export const TECH_PINK = "#D98BB0";
export const TECH_UNASSIGNED = "#9AA3AB";

export function technicianColor(name, orderedNames) {
  if (!name || name === "Unassigned") return TECH_UNASSIGNED;
  if (name === "Heike Kolar") return TECH_PINK;
  const others = (orderedNames || []).filter((n) => n !== "Unassigned" && n !== "Heike Kolar");
  const idx = others.indexOf(name);
  return TECH_PALETTE[idx >= 0 ? idx % TECH_PALETTE.length : 0];
}
